import config from 'config/appConfig';
import lineIcon from 'assets/images/line_icon.png';
/**
 * LINE友だち追加ボタンコンポーネント
 */
export default function LineButton(props: { url: string }): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------- */
  /* プライベート関数 */
  /* ----------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div className="btn-container">
      <span className="ql-button line-button">
        <a href={props.url} target="_blank">
          <div className="line-button-cover" />
          <div className="line-icon-container">
            <img className="line-icon" src={`${config.rootPath}${lineIcon}`} />
          </div>
          <span className="line-context">今すぐLINEではじめる</span>
        </a>
      </span>
    </div>
  );
}
